import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDiagramProject,
  faUsers,
  faUserTie,
  faCode,
} from "@fortawesome/free-solid-svg-icons";
import "./stats.styles.css";

const Stats = (props) => {
  return (
    <section id="stats">
      <Container>
        <Row>
          <Col lg={3}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5 }}
              className="stats-card"
            >
              <FontAwesomeIcon icon={faDiagramProject} className="fontAwIcon" />
              <h2 className="statTitle">10+</h2>
              <h6 className="statSubTitle">NO OF PROJECTS</h6>
            </motion.div>
          </Col>
          <Col lg={3}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5 }}
              className="stats-card"
            >
              <FontAwesomeIcon icon={faUsers} className="fontAwIcon" />
              <h2 className="statTitle">5+</h2>
              <h6 className="statSubTitle">NO OF CLIENTS</h6>
            </motion.div>
          </Col>
          <Col lg={3}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5 }}
              className="stats-card"
            >
              <FontAwesomeIcon icon={faUserTie} className="fontAwIcon" />
              <h2 className="statTitle">50+</h2>
              <h6 className="statSubTitle">NO OF EMPLOYEE</h6>
            </motion.div>
          </Col>
          <Col lg={3}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.5 }}
              className="stats-card"
            >
              <FontAwesomeIcon icon={faCode} className="fontAwIcon" />
              <h2 className="statTitle">10K+</h2>
              <h6 className="statSubTitle">HOURS OF CODING</h6>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Stats);
